import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminOrganizationDetailsPage = () => {
  return (
    <>
      <Helmet>
        <title>Organization Details - AutoScript Admin</title>
      </Helmet>
      <Header title="Organization Details" backRoute={routes.adminOrganizationsList.make()} />

      <Content />
    </>
  );
};
